import { render } from "./P2PFilters.vue?vue&type=template&id=cb4e04e6"
import script from "./P2PFilters.vue?vue&type=script&lang=js"
export * from "./P2PFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__